export default __webpack_public_path__ + "static/media/trending.07779a6a.png";